import React, { FunctionComponent } from 'react';
import { ButtonsFieldProps } from './types';
import { Button } from 'react-admin';
import { useHistory } from 'react-router';
import DownloadIcon from '@material-ui/icons/GetApp';

const ButtonsField: FunctionComponent<ButtonsFieldProps> = (
  props: ButtonsFieldProps
) => {
  const { record, source } = props;
  const history = useHistory();

  if (!record || !source || !record[source]) return null;
  const buttons = Array.isArray(record[source])
    ? record[source]
    : [record[source]];

  return (
    <div>
      {buttons.map((buttonProps: Record<string, any>) => {
        const { to, ...rest } = buttonProps;
        const handleClick = (e: React.MouseEvent) => {
          if (to) {
            e.preventDefault();
            e.stopPropagation();
            history.push(to);
          }
        };

        return buttonProps.icon ? (
          <Button
            key={buttonProps.id}
            {...buttonProps}
            {...(to && { onClick: handleClick })}
          >
            <DownloadIcon />
          </Button>
        ) : (
          <Button
            key={buttonProps.id}
            {...buttonProps}
            {...(to && { onClick: handleClick })}
          />
        );
      })}
    </div>
  );
};

export default ButtonsField;
